/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量5
 * @export
 * @interface Col5
 */
export interface Col5 {
}

/**
 * Check if a given object implements the Col5 interface.
 */
export function instanceOfCol5(value: object): value is Col5 {
    return true;
}

export function Col5FromJSON(json: any): Col5 {
    return Col5FromJSONTyped(json, false);
}

export function Col5FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col5 {
    return json;
}

export function Col5ToJSON(json: any): Col5 {
    return Col5ToJSONTyped(json, false);
}

export function Col5ToJSONTyped(value?: Col5 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

